import {
  getInitials,
  handleAssetRequestStatus,
  handleAttendanceStatus,
  handleStatus,
} from '@/utility/CommonFunctions';
import NoRecordIcon from '../Icons/NoRecordIcon';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import Button from '../ui/Button';
import { IActionData, ITableColumn } from './CommonTable';
import { capitalizeFirstLetter } from '@/utility/helper';
import { ITableRowData } from '@/interfaces/common.model';
import AssetIcon from '../Icons/AssetIcon';
import moment from 'moment';
interface ICardView<T extends ITableRowData> {
  tableData: T[];
  tableHeading: ITableColumn<T>[];
  loading: boolean;
  handleStatusToggle?: (
    data: T,
    status: boolean,
    heading?: string | number,
  ) => void;
  handleViewDetail?: (data: T) => void;
  handleChangeAttendance?: (
    newStatus: number,
    userId: string,
    userName: string,
  ) => void;
  ActionData?: IActionData<T>[];
}
const attendanceKeys = [
  'presentDays',
  'pending',
  'absent',
  'leaves',
  'pendingAr',
  'pendingOd',
  'pendingLeave',
  'totalDay',
  'totalHalfDays',
  'totalFullDayWfh',
  'totalHalfDayWfh',
] as const;
interface IAttendanceSummarykey {
  presentDays: string;
  pending: string;
  absent: string;
  leaves: string;
  pendingAr: string;
  pendingOd: string;
  pendingLeave: string;
  totalDay: string;
  totalHalfDays: string;
  totalFullDayWfh: string;
  totalHalfDayWfh: string;
}
interface IAttendanceSummary {
  key: keyof IAttendanceSummarykey;
  label: string;
  className: string;
}
function CardView<T extends ITableRowData>({
  loading,
  tableData,
  tableHeading,
  handleViewDetail,
  handleChangeAttendance,
  ActionData,
}: ICardView<T>) {
  const userDetails = useSelector((state: RootState) => state?.user?.user);
  const attendanceSummary: IAttendanceSummary[] = [
    { key: 'presentDays', label: 'Present', className: 'present' },
    { key: 'absent', label: 'Absent', className: 'absent' },
    { key: 'pending', label: 'Pending', className: 'pending' },
    { key: 'leaves', label: 'Leaves', className: 'absent' },
    { key: 'totalFullDayWfh', label: 'WFH', className: 'total' },
    { key: 'pendingAr', label: 'Pending AR', className: 'pending' },
    { key: 'pendingOd', label: 'Pending WFH', className: 'pending' },
    { key: 'pendingLeave', label: 'Pending Leave', className: 'pending' },
    { key: 'totalDay', label: 'Total Days', className: 'total' },

    // { key: 'totalHalfDays', label: 'Half Day Leaves', className: 'total' },
    // { key: 'totalHalfDayWfh', label: 'Half Day WFH', className: 'total' },
  ];
  function hasAttendance<T extends object>(
    data: T,
  ): data is T & IAttendanceSummarykey {
    return attendanceKeys.every(
      (key): key is keyof IAttendanceSummarykey => key in data,
    );
  }
  const renderCard = (heading: ITableColumn<T>, data: T, index: number) => {
    switch (heading?.value) {
      case 'index':
        return;
      // case 'companylogo':
      //   return (
      //     <>
      //       <div className="d-flex align-items-center">
      //         <div className="cardView_img mx-3">
      //           {data[heading?.value] ? (
      //           <img
      //               src={String(data[heading?.value]).trim()}
      //               className="img-fluid"
      //             alt="profile"
      //             loading="lazy"
      //             style={{ backgroundColor: 'rgb(240 247 249)' }}
      //           />
      //         ) : (
      //           <img
      //             loading="lazy"
      //             src={'public/company.jpeg'}
      //             className="img-fluid"
      //               alt="profile"
      //               style={{ backgroundColor: 'rgb(240 247 249)' }}
      //             />
      //           {/* <img
      //             src={String(data[heading?.value] ?? '').trim()}
      //             className="img-fluid"
      //             alt="profile"
      //             style={{ backgroundColor: 'rgb(240 247 249)' }}
      //           /> */}
      //           )}
      //       </div>
      //         <div>
      //           <h5 className="fw-bold mb-1">{data?.name}</h5>
      //           {'email' in data && (
      //             <div>
      //               <span className="text-truncate fw-medium ">
      //                 {data?.email == null ? '--' : String(data?.email)}
      //               </span>
      //             </div>
      //           )}
      //         </div>
      //       </div>
      //     </>
      //   );
      case 'details':
        return (
          <>
            {/* details */}
            <div className="d-flex align-items-center gap-3 mb-4">
              <div
                className="rounded-3 bg-primary-subtle text-primary d-flex align-items-center justify-content-center"
                style={{ minWidth: '42px', minHeight: '42px' }}
              >
                <AssetIcon />
              </div>
              <div className="overflow-hidden">
                <h4 className="mb-1 fw-bold text-nowrap text-truncate">
                  {data?.asset}
                </h4>

                <span className="text-muted d-block fs-5">
                  Category: {data?.assetCategory}
                </span>
              </div>
            </div>

            <div className="flex-grow-1 mb-3">
              <p className="card-text small text-secondary text-truncate mb-4">
                <span>Description:</span> {data?.description}
              </p>
              <div className="d-flex align-items-center gap-5 row-gap-4 flex-wrap">
                {data.isTransfer && (
                  <div className=" small text-muted">
                    <i className="bi bi-calendar-event me-1"></i> Transfer:{' '}
                    {moment(data.receivedAt).format('DD MMM YYYY')}
                  </div>
                )}
                {data?.createdAt && (
                  <div className="small text-muted">
                    <i className="bi bi-calendar-event me-1"></i>Requested On :
                    {moment(data.createdAt).format('DD MMM YYYY')}
                  </div>
                )}
                {data?.isReturn && (
                  <div className="small text-muted">
                    <i className="bi bi-calendar-event me-1"></i> Return On :{' '}
                    {moment(data.updatedAt).format('DD MMM YYYY')}
                  </div>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-between pt-3 border-top mt-auto">
              {/* <span className="badge rounded-pill bg-success-subtle text-success fw-medium"> */}
              {handleAssetRequestStatus(
                Number(data?.assetRequestStatus),
                Boolean(data?.isReturn),
                Boolean(data?.isTransfer),
              )}
              {/* </span> */}
              {/* <div className="btn-group btn-group-sm">
              <button className="btn btn-outline-secondary border-0"><i className="bi bi-arrow-left-right"></i></button>
              <button className="btn btn-outline-secondary border-0"><i className="bi bi-reply"></i></button>
              <button className="btn btn-outline-secondary border-0"><i className="bi bi-pencil"></i></button>
              <button className="btn btn-outline-secondary border-0 text-danger"><i className="bi bi-trash"></i></button>
            </div> */}
            </div>
          </>
        );
      case 'AttendanceLockStatus': {
        if (data[heading.value] === true) {
          return (
            <>
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <span className="text-muted">{heading.label}:</span>
                  </div>
                  <div className="col-6 text-truncate">
                    <span className="badge bg-green-25 fw-normal rounded-pill">
                      Yes
                    </span>
                  </div>
                </div>
              </div>
            </>
          );
        } else {
          return (
            <>
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <span className="text-muted">{heading.label}:</span>
                  </div>
                  <div className="col-6 text-truncate">
                    <span className="badge bg-red-25 fw-normal rounded-pill">
                      No
                    </span>
                  </div>
                </div>
              </div>
            </>
          );
        }
      }
      case 'salaryStatus': {
        if (data[heading.value] === true) {
          return (
            <>
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <span className="text-muted">{heading.label}:</span>
                  </div>
                  <div className="col-6">
                    <span className="badge  bg-green-25 fw-normal rounded-pill">
                      Yes
                    </span>
                  </div>
                </div>
              </div>
            </>
          );
        } else {
          return (
            <>
              <div className="col-12">
                <div className="row">
                  <div className="col-6">
                    <span className="text-muted">{heading.label}:</span>
                  </div>
                  <div className="col-6">
                    <span className="badge bg-red-25 fw-normal rounded-pill">
                      No
                    </span>
                  </div>
                </div>
              </div>
            </>
          );
        }
      }
      case 'totalHalfDays':
      case 'totalFullDayWfh':
      case 'totalHalfDayWfh':
      case 'canAccessTeam':
      case 'toggleStatus':
      case 'gst':
      case 'phone':
      case 'shortName':
      case 'email':
      case 'companyName':
      case 'employeeCode':
      case 'dateOfJoin':
      case 'employeeStatus':
      case 'salary':
      case 'role':
      case 'department':
      case 'shiftTime':
      case 'officeName':
      case 'presentDays':
      case 'absent':
      case 'pending':
      case 'leaves':
      case 'pendingAr':
      case 'pendingOd':
      case 'pendingLeave':
      case 'totalDay':
      case 'asset':
      case 'sno':
      case 'assetRequestStatus':
        return null;

      case 'attendanceStatus':
        return (
          <>
            <div className="col-12">
              <div className="row">
                <div className="col-6">
                  <span className="text-muted">{heading.label}: </span>
                </div>
                <div className="col-6 text-truncate">
                  <span className="fw-bold">
                    {handleAttendanceStatus(Number(data[heading?.value]))}
                  </span>
                </div>
              </div>
            </div>
          </>
        );
      case 'leaveStatus':
      case 'status':
        return (
          <>
            <div className="col-12" key={index}>
              <div className="row">
                <div className="col-6">
                  <span className="text-muted">{heading.label}: </span>
                </div>
                <div className="col-6 text-truncate">
                  {handleStatus(Number(data[heading.value]))}
                </div>
              </div>
            </div>
          </>
        );
      case 'unpaid': {
        const isUnpaid =
          data[heading.value] === 'Yes' || data[heading.value] === true;
        return (
          <>
            <div className="col-12" key={index}>
              <div className="row">
                <div className="col-6">
                  <span className="text-muted">{heading.label}: </span>
                </div>
                <div className="col-6 text-truncate">
                  <span
                    className={`badge ${
                      isUnpaid ? 'bg-red-25' : 'bg-green-25'
                    } fw-normal rounded-pill`}
                  >
                    {isUnpaid ? 'Yes' : 'No'}
                  </span>
                </div>
              </div>
            </div>
          </>
        );
      }

      case 'empNameWithImage': {
        const emp = String(data[heading.value] ?? '');
        const [name, image] = emp.split('##');
        return (
          <>
            <div className="d-flex align-items-center gap-3 pb-2">
              <div className="cardView_img">
                {image != 'null' ? (
                  <img
                    src={image}
                    alt="User"
                    className="user-avatar me-2"
                    loading="lazy"
                  />
                ) : (
                  <span className="user-icon me-2">{getInitials(name)}</span>
                )}
              </div>
              <div
                className=""
                onClick={
                  handleViewDetail ? () => handleViewDetail(data) : () => {}
                }
                style={{
                  cursor: handleViewDetail ? 'pointer' : 'text',
                }}
              >
                <h4
                  className="title mb-0 title_box"
                  style={{ fontSize: '14px!important' }}
                >
                  {capitalizeFirstLetter(name)} ({data.employeeCode})
                </h4>

                <h4
                  className="title mb-0 title_box"
                  style={{ fontSize: '14px!important' }}
                >
                  {data.department as string}
                  {'-'}
                  {data.role as string}
                </h4>
              </div>
            </div>
            {hasAttendance(data) && (
              <div className="chip-group d-flex align-items-center flex-wrap gap-3 pt-3 border-top">
                {attendanceSummary?.map(
                  ({ key, label, className }) =>
                    data[key] !== undefined &&
                    data[key] !== null && (
                      <div
                        key={key}
                        className={`chip d-flex align-items-center gap-2 text-nowrap ${className}`}
                      >
                        {label} <strong>{data[key]}</strong>
                      </div>
                    ),
                )}
              </div>
            )}
            {/* {'presentDays' in data && (
              <div className="chip-group d-flex align-items-center flex-wrap gap-3 pt-3 border-top">
                <div className="chip d-flex align-items-center gap-2 text-nowrap present">
                  Present <strong>{data?.presentDays as string}</strong>
                </div>
                <div className="chip d-flex align-items-center gap-2 text-nowrap absent">
                  Absent <strong>{data?.presentDays as string}</strong>
                </div>
                <div className="chip d-flex align-items-center gap-2 text-nowrap pending">
                  Pending <strong>{data?.pending as string}</strong>
                </div>
                <div className="chip d-flex align-items-center gap-2 text-nowrap total">
                  Leaves <strong>{data?.leaves as string}</strong>
                </div>
                <div className="chip d-flex align-items-center gap-2 text-nowrap pending">
                  Pending AR <strong>{data?.pendingAr as string}</strong>
                </div>
                <div className="chip d-flex align-items-center gap-2 text-nowrap pending">
                  Pending WFH <strong>{data?.pendingOd as string}</strong>
                </div>
                <div className="chip d-flex align-items-center gap-2 text-nowrap pending">
                  Pending Leave <strong>{data?.pendingLeave as string}</strong>
                </div>
                <div className="chip d-flex align-items-center gap-2 text-nowrap total">
                  Total Days <strong>{data?.totalDay as string}</strong>
                </div>
              </div>
            )} */}
          </>
        );
      }

      case 'attendanceStatusToggle': {
        const getClassName = () => {
          switch (data[heading.value]) {
            case 1:
              return 'text-success';
            case 0:
              return 'text-danger';
            case 2:
              return 'text-warning';
            case 3:
              return 'text-info';
            case 4:
              return 'text-warning';
            case 5:
              return 'text-warning';
            case 6:
              return 'text-warning';
            default:
              return '';
          }
        };
        return (
          <>
            <div className="col-12">
              <div className="row">
                <div className="col-6">
                  <span className="text-muted">{heading.label}: </span>
                </div>
                <div className="col-6 text-truncate">
                  <select
                    className={`form-select fw-normal status-dropdown rounded-4 px-3 ${getClassName()}`}
                    defaultValue={String(data[heading.value])}
                    value={String(data[heading.value])}
                    onChange={(e) =>
                      handleChangeAttendance &&
                      handleChangeAttendance(
                        Number(e.target.value),
                        data.id,
                        data.name ?? '',
                      )
                    }
                    disabled={userDetails?.designation?.name !== 'HR'}
                  >
                    {
                      <option style={{ color: 'green' }} value={1}>
                        Present
                      </option>
                    }
                    <option style={{ color: 'red' }} value={0}>
                      Absent
                    </option>
                    <option
                      style={{ color: 'orange', display: 'none' }}
                      disabled
                      value={2}
                    >
                      Pending
                    </option>
                    {
                      <option style={{ color: 'cyan' }} value={3}>
                        On Leave
                      </option>
                    }
                    {
                      <option
                        className="d-none"
                        style={{ color: 'orange' }}
                        value={4}
                      >
                        Pending Leave
                      </option>
                    }
                    {
                      <option
                        className="d-none"
                        style={{ color: 'orange' }}
                        value={5}
                      >
                        Pending AR
                      </option>
                    }
                    {
                      <option
                        className="d-none"
                        style={{ color: 'orange' }}
                        value={6}
                      >
                        Pending OD
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </>
        );
      }
      default:
        return (
          <>
            <div className="d-flex align-items-center">
              <div>
                <span className="text-muted">{heading.label}: </span>
              </div>
              <div className="text-truncate">
                <span className="text-truncate fw-medium ">
                  {data?.[heading.value] == null
                    ? '--'
                    : String(data?.[heading.value])}
                </span>
              </div>
            </div>
            {/* <div className="col-12">
              <div className="row">
                <div className="col-6">
                  <span className="text-muted">{heading.label}: </span>
                </div>
                <div className="col-6 text-truncate">
                  <span className="text-truncate fw-medium ">
                    {data?.[heading.value] == null
                      ? '--'
                      : String(data?.[heading.value])}
                  </span>
                </div>
              </div>
            </div> */}
          </>
        );
    }
  };
  return (
    <>
      {' '}
      {loading ? (
        <>
          <div className="row row-gap-3 gap-3 mx-0">
            <div className="col-md-12">
              <div className="row">
                {(tableData?.length
                  ? tableData
                  : Array.from({ length: 6 })
                ).map((_, index) => (
                  <div className="col-md-6 col-lg-4" key={index}>
                    <div className="card profile-card border shadow rounded-4 p-3">
                      <div className="skeleton skeleton-avatar mb-3" />
                      <div className="skeleton skeleton-text mb-2" />
                      <div className="skeleton skeleton-text w-75 mb-2" />
                      <div className="d-flex gap-2 mt-3 flex-wrap">
                        <div className="skeleton skeleton-chip" />
                        <div className="skeleton skeleton-chip" />
                        <div className="skeleton skeleton-chip" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {tableData?.length > 0 ? (
            <div className="row row-gap-3 gap-3 mx-0">
              <div className="col-md-12">
                <div className="row">
                  {tableData?.length > 0 &&
                    tableData.map((data, index) => (
                      <div className="col-md-6 col-lg-4">
                        <div
                          className="card profile-card border shadow rounded-4 p-0 position-relative"
                          key={index}
                        >
                          <div className="card-body p-3">
                            <div className="dropdown d-flex justify-content-end gridCard_dropdown position-absolute top-0 end-0">
                              <button
                                className="btn p-0 border-0 bg-transparent"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                <i className="bi bi-three-dots-vertical fs-4"></i>
                              </button>
                              <ul className="dropdown-menu dropdown-menu-end shadow-sm custom-dd">
                                {ActionData?.map((action) => {
                                  if (
                                    action.isHidden &&
                                    action.isHidden(data)
                                  ) {
                                    return null;
                                  }
                                  return (
                                    <li>
                                      <Button
                                        onClick={() =>
                                          action?.clickHandler(data)
                                        }
                                        className="dropdown-item"
                                      >
                                        {action?.label}
                                      </Button>
                                    </li>
                                  );
                                })}
                              </ul>
                            </div>
                            <div className="row">
                              <div className="col-12">
                                {tableHeading.map((heading) => (
                                  <> {renderCard(heading, data, index)}</>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          ) : (
            <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
              <NoRecordIcon />
              {'No record found'}
            </div>
          )}
        </>
      )}
    </>
  );
}
export default CardView;
